import { useMemo } from 'react';

import { useGetPoolsList } from '../CashFlowModeling/getListingsList_gql';

interface Props {
  assetClass: string | null;
}
export const usePoolOptions = ({ assetClass }: Props) => {
  const { data: poolsList } = useGetPoolsList();

  const poolOptions = useMemo(() => {
    const normalizedAssetClass = assetClass?.toLowerCase();

    return poolsList?.user.company.pools
      ?.filter((listing) => listing.asset_class.toLowerCase() === normalizedAssetClass)
      ?.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        return nameA.localeCompare(nameB);
      })
      ?.map((listing) => ({
        label: listing.name,
        value: listing.id,
        poolData: listing,
      }));
  }, [poolsList?.user.company.pools, assetClass]);

  return {
    poolOptions,
  };
};
